import { render, staticRenderFns } from "./HowItWorksSection.vue?vue&type=template&id=05026c1a&"
import script from "./HowItWorksSection.vue?vue&type=script&lang=js&"
export * from "./HowItWorksSection.vue?vue&type=script&lang=js&"
import style0 from "./HowItWorksSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HowItWorksSection.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VFlex,
  VIcon,
  VLayout,
})
